import { render, staticRenderFns } from "./DynamicAlert.vue?vue&type=template&id=d7073408&"
import script from "./DynamicAlert.vue?vue&type=script&lang=js&"
export * from "./DynamicAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports